import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Blog from '@/components/Blog'
import tempo from '@/components/tempo'
import Popup from '@/components/Popup'
import Galery from '@/components/Galery'

Vue.use(Router)

var router = new Router({
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    mode: 'history',
    routes: [
        {
            name: '/',
            path: '/',
            component: Home
        },
        {
            name: 'Home',
            path: '/Home',
            component: Home
        },
        {
            name: 'Blog',
            path: '/Blog',
            component: Blog
        },
        {
            name: 'tempo',
            path: '/tempo',
            component: tempo
        },
        {
            name: 'Popup',
            path: '/Popup',
            component: Popup
        },
        {
            name: 'Galery',
            path: '/Galery',
            component: Galery
        }
    ]
})
export default router

router.beforeEach((to, from, next) => {
    // console.log('beforeEach::popStateDetected:: ', window.popStateDetected);
    // console.log('beforeEach::to:: ', to);
    // console.log('beforeEach::to:: ', (Object.keys(to.params).length === 0) );
    // console.log('beforeEach::from:: ', from);

    // Redirect if fullPath begins with a hash (ignore hashes later in path)
    if (to.fullPath.substr(0, 2) === '/#') {
        const path = to.fullPath.substr(2)
        next(path)
        return
    }
    next()
})



// WEBPACK FOOTER //
// ./src/router/index.js